
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opinions/[opinionSlug]",
      function () {
        return require("private-next-pages/opinions/[opinionSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opinions/[opinionSlug]"])
      });
    }
  